var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06226 3.0625C3.06124 3.0625 2.24976 3.87398 2.24976 4.875V6.75C2.24976 7.75102 3.06124 8.5625 4.06226 8.5625H5.31226C6.31327 8.5625 7.12476 7.75102 7.12476 6.75V4.875C7.12476 3.87398 6.31327 3.0625 5.31226 3.0625H4.06226ZM3.37476 4.875C3.37476 4.4953 3.68256 4.1875 4.06226 4.1875H5.31226C5.69195 4.1875 5.99976 4.4953 5.99976 4.875V6.75C5.99976 7.1297 5.69195 7.4375 5.31226 7.4375H4.06226C3.68256 7.4375 3.37476 7.1297 3.37476 6.75V4.875Z",
    fill: "#748399"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68726 7.4375C8.68624 7.4375 7.87476 8.24898 7.87476 9.25V11.125C7.87476 12.126 8.68624 12.9375 9.68726 12.9375H10.9373C11.9383 12.9375 12.7498 12.126 12.7498 11.125V9.25C12.7498 8.24898 11.9383 7.4375 10.9373 7.4375H9.68726ZM8.99976 9.25C8.99976 8.87031 9.30756 8.5625 9.68726 8.5625H10.9373C11.317 8.5625 11.6248 8.87031 11.6248 9.25V11.125C11.6248 11.5047 11.317 11.8125 10.9373 11.8125H9.68726C9.30756 11.8125 8.99976 11.5047 8.99976 11.125V9.25Z",
    fill: "#748399"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.24976 11.125C2.24976 10.124 3.06124 9.3125 4.06226 9.3125H5.31226C6.31327 9.3125 7.12476 10.124 7.12476 11.125C7.12476 12.126 6.31327 12.9375 5.31226 12.9375H4.06226C3.06124 12.9375 2.24976 12.126 2.24976 11.125ZM4.06226 10.4375C3.68256 10.4375 3.37476 10.7453 3.37476 11.125C3.37476 11.5047 3.68256 11.8125 4.06226 11.8125H5.31226C5.69195 11.8125 5.99976 11.5047 5.99976 11.125C5.99976 10.7453 5.69195 10.4375 5.31226 10.4375H4.06226Z",
    fill: "#748399"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68726 3.0625C8.68624 3.0625 7.87476 3.87398 7.87476 4.875C7.87476 5.87602 8.68624 6.6875 9.68726 6.6875H10.9373C11.9383 6.6875 12.7498 5.87602 12.7498 4.875C12.7498 3.87398 11.9383 3.0625 10.9373 3.0625H9.68726ZM8.99976 4.875C8.99976 4.4953 9.30756 4.1875 9.68726 4.1875H10.9373C11.317 4.1875 11.6248 4.4953 11.6248 4.875C11.6248 5.2547 11.317 5.5625 10.9373 5.5625H9.68726C9.30756 5.5625 8.99976 5.2547 8.99976 4.875Z",
    fill: "#748399"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a90c85a0ef71a4dc73bf467b036d3e79.svg";
export { ForwardRef as ReactComponent };